import React from "react";
import { BookOpen } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import { RowLineSkeleton } from "../Skeleton/StatsSkeleton.jsx";

/* ===================== STYLES ===================== */
import styles from "./ApiIntro.module.scss";

const ApiIntro = ({ intro }) => {
  // If no intro is provided, we treat it as loading/empty state
  const loading = !intro;

  return (
    <div className={styles["admin-ac-intro__card"]}>
      <div className={styles["admin-ac-intro__header"]}>
        <div className={styles["admin-ac-intro__icon-wrapper"]}>
          <BookOpen size={18} strokeWidth={2.5} />
        </div>
        <h3 className={styles["admin-ac-intro__title"]}>Introduction</h3>
      </div>

      <div className={styles["admin-ac-intro__content"]}>
        {loading ? (
          <RowLineSkeleton />
        ) : (
          <p
            className={`${styles["admin-ac-intro__text"]} ${
              !intro ? styles["admin-ac-intro__text--empty"] : ""
            }`}
          >
            {intro || "Select an API to view introduction"}
          </p>
        )}
      </div>
    </div>
  );
};

export default ApiIntro;
